import _ from 'lodash';
import { numericFormat } from '@ipreo/muni-shared';

export function formatRange(
  value: any[] | any,
  style: 'decimal' | 'percent' | 'currency' = 'decimal',
  none = ''
): string {
  if (value === undefined || value === null || Number.isNaN(value)) {
    // tslint:disable-line:no-null-keyword
    return none;
  }

  const values = Array.isArray(value) ? value : [value];
  const numberFormat = numericFormat[style] || numericFormat['decimal']; // tslint:disable-line:no-string-literal
  const factor = numberFormat.resolvedOptions().style === 'percent' ? 0.01 : 1;

  const result = _(values)
    .filter(c => typeof c === 'number' && !Number.isNaN(c))
    .uniq()
    .sortBy()
    .remove((v, i, arr) => i === 0 || i === arr.length - 1)
    .map(c => numberFormat.format(c * factor).replace(/\s+/g, ''))
    .value()
    .join('–');

  return result || none;
}
